import { MODE_STRONG, NONCE_LEN } from "./constants";
import { encodePresentation, presentationSigningInput } from "./format";
import { signWithDevice } from "./crypto";

/**
 * Named extension point. In fast mode the holder picks the nonce so the
 * verifier can reject repeats; in strong mode the verifier supplies it and
 * there is no replay window at all.
 */
export function chooseNonce(mode: number, verifierNonce?: Uint8Array): Uint8Array {
  if (mode === MODE_STRONG) {
    if (!verifierNonce || verifierNonce.length !== NONCE_LEN) {
      throw new Error(`strong mode needs a ${NONCE_LEN}-byte verifier nonce`);
    }
    return verifierNonce;
  }
  return crypto.getRandomValues(new Uint8Array(NONCE_LEN));
}

export async function buildPresentation(args: {
  credentialBytes: Uint8Array;
  deviceKey: CryptoKey;
  nonce: Uint8Array;
  mode: number;
  timestamp: number;
  errandBytes?: Uint8Array;
}): Promise<Uint8Array> {
  const fields = {
    credentialBytes: args.credentialBytes,
    timestamp: args.timestamp,
    nonce: args.nonce,
    mode: args.mode,
    errandBytes: args.errandBytes,
  };
  const signature = await signWithDevice(args.deviceKey, presentationSigningInput(fields));
  return encodePresentation({ ...fields, signature });
}
